import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { ClipConfigCanvas } from '@/features/app-shell/canvases/clip-config-canvas'

type ClipConfigSearch = {
  src: string
  title?: string
}

export const Route = createFileRoute('/app/clip-config')({
  validateSearch: (search: Record<string, unknown>): ClipConfigSearch => ({
    src: typeof search.src === 'string' ? search.src : '',
    title: typeof search.title === 'string' ? search.title : undefined,
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: ClipConfigRoute,
})

function ClipConfigRoute() {
  return <ClipConfigCanvas />
}
